import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import { getOauthUrl, logout } from '../../../ajax/endpoints';
import getCurrentOrganizationId from '../../../utils/getCurrentOrganizationId';
import svgInline from '../../SvgInline/SvgInline';
import getHelpIcon from '../../../shared/assets/icon-help.svg';

import FolderManager from '../FolderManager';

class FavoritesHeader extends Component {
  constructor(props) {
    super(props);

    this.onLogin = this.onLogin.bind(this);
    this.onLogout = this.onLogout.bind(this);
  }

  onLogin() {
    const organizationId = getCurrentOrganizationId(window);
    if (organizationId) {
      const d = new Date();
      d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
      window.document.cookie = `organization=${organizationId}; Expires=${d.toUTCString()}`;
    }

    if (window.self !== window.top) {
      window.open(getOauthUrl('google'));
    } else {
      window.location = getOauthUrl('google');
    }
  }

  onLogout() {
    logout().then(() => {
      window.location.reload();
    });
  }

  render() {
    const {
      onExport,
      authenticated,
      displayName,
      showShareModal,
      showFolderInstructionsModal,
    } = this.props;
    return (
      <div className="favorites__header">
        <div className="favorites-header-left">
          <FolderManager
            className="favorites__folder"
            supportsAdd
            supportsDelete
            supportsEdit
            selectType="dropdown"
            mode="default"
          />
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <button
              className="btn"
              style={{ marginTop: 12 }}
              type="button"
              onClick={onExport}
            >
              Create Report
            </button>
          </ViewerPrimaryColorUserStyle>
          <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
            <button
              className="btn"
              style={{ marginLeft: 10, marginTop: 12 }}
              type="button"
              onClick={showShareModal}
            >
              Share
            </button>
          </ViewerPrimaryColorUserStyle>
        </div>
        <div className="favorites-header-right">
          <div className="favorites-instructions">
            {authenticated &&
              <div className="user-welcome">
                Welcome, {displayName}
              </div>
            }
            <a className="help-link" tabIndex="0" onClick={showFolderInstructionsModal}>
              Need Help {svgInline(getHelpIcon)}
            </a>
          </div>
          {!authenticated && (
            <div className="login-button-wrap">
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <button
                  className="btn"
                  type="button"
                  onClick={this.onLogin}
                >
                  Log In With Gmail
                </button>
              </ViewerPrimaryColorUserStyle>
            </div>
          )}
          {authenticated &&
            <div className="login-button-wrap">
              <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
                <button
                  className="btn"
                  type="button"
                  onClick={this.onLogout}
                >
                  Log Out
                </button>
              </ViewerPrimaryColorUserStyle>
            </div>
          }
        </div>
      </div>
    );
  }
}

FavoritesHeader.propTypes = {
  authenticated: PropTypes.bool,
  displayName: PropTypes.string,
  onExport: PropTypes.func.isRequired,
  showShareModal: PropTypes.func.isRequired,
  showFolderInstructionsModal: PropTypes.func.isRequired,
};

export default FavoritesHeader;



// WEBPACK FOOTER //
// ./src/components/Favorites/FavoritesHeader/FavoritesHeader.js